import React, { Component } from "react";
import Page from "react-page-loading";
import { Pie, Line, Bar, Chart, Doughnut } from 'react-chartjs-2';

import Header from "./common/Header";
import Sidebar from "./common/Sidebar";
import { Link } from "react-router-dom";

import axios from "axios";
import swal from "sweetalert";


export class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage["appState"]
        ? JSON.parse(localStorage["appState"]).user.token
        : "",
      user: [],
      plan_count: "",
      plan_current: "",
      plan_total: "",
    };
  }
  componentDidMount() {
    axios
      .get(
        `${axios.defaults.baseURL}/user/${
          JSON.parse(localStorage["appState"]).user.id
        }`,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({
            user: json.data.user[0],
            plan_count: json.data.plans_count,
            plan_current: json.data.plans_current,
            plan_total: json.data.plans_total,
          });
          // } else alert("Cannot Fetch Data!");
        } else swal("Oops!", "Cannot Fetch Data!", "error");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
    // alert(id)
  }
  logoutUser = () => {
    localStorage.clear();
    window.location.href = "/auth";
  };
  render() {

    var r_balance = this.state.plan_total - this.state.plan_current;
    const doudata = {
      labels: [
        'Payments',
        'Balance',
      ],
      datasets: [{
        data: [this.state.plan_current, r_balance],
        backgroundColor: [
        '#449400',
        '#FD5B00',
        ]
      }]
    };

    return (
      <>
        <Page loader={"spin"} color={"#449400"} duration={1} size={10}>
          <div id="app" className="bg-gray-200">
            <div className="dashboard-page">
              <div className="private-layout">
                <div className="app-wrapper">
                  <Sidebar />
                  <Header />
                  <div id="main-app" className="position-relative">
                    <div className="container mt-4">
                      <div className="row align-items-stretch">
                        <div className="mb-4 portfolio-card col-lg-12 col-12">
                          <div className="wrapper h-100 p-4 dash-card shadow-xl invest-bg col">
                            <div className="row">
                              <div className="col-12">
                                <small className="mb-2 h6 text-dark font-weight-bolder">
                                  Welcome
                                  <span className="strong">
                                    {" "}
                                    {this.state.user.lname || ""}
                                  </span>
                                  ,
                                </small>
                                <small
                                  className="ml-1"
                                  style={{ marginTop: "-10px" }}
                                ></small>
                                <h3
                                  style={{
                                    marginTop: "50px",
                                    fontStyle: "italic",
                                  }}
                                >
                                  Enjoy Affordable Homes and Lands
                                  <br />
                                  with Super Convenient Payment Plans
                                </h3>
                                <div
                                  className="text-primary"
                                  style={{ marginTop: "50px" }}
                                >
                                  <div>
                                    <Link
                                      to="/evest"
                                      className="btn btn-primary"
                                      style={{ marginRight: "10px" }}
                                    >
                                      Buy a House 🔥
                                    </Link>
                                    <Link
                                      to="/landvest"
                                      className="btn btn-dark"
                                    >
                                      Buy a Land
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.plan_count == 0 ? (
                        <div className="row">
                          <div class="mb-2 col-md-6 col-12">
                            <Link
                              to="/evest"
                              class="btn dash-card p-4 shadow-xl outline evest action-btn w-100 btn-secondary"
                              target="_self"
                            >
                              <div class="text-left">
                                <i class="ti-home text-primary"></i>
                                <h6 class="text-primary">EVest</h6>
                              </div>

                              <Link
                                to="/evest"
                                className="btn btn-primary mt-4"
                                style={{
                                  marginRight: "0px",
                                  backgroundColor: "",
                                }}
                              >
                                Start Plan
                              </Link>
                            </Link>
                          </div>
                          <div class="mb-2 col-md-6 col-12">
                            <Link
                              to="/landvest"
                              class="btn dash-card p-4 shadow-xl outline lvest action-btn w-100 btn-secondary"
                              target="_self"
                            >
                              <div class="text-left">
                                <i class="ti-map text-primary"></i>
                                <h6 class="text-primary">LandVest</h6>
                              </div>

                              <Link
                                to="/landvest"
                                className="btn btn-primary mt-4"
                                style={{
                                  marginRight: "0px",
                                  backgroundColor: "",
                                }}
                              >
                                Start Plan
                              </Link>
                            </Link>
                          </div>
                        </div>
                      ) : this.state.plan_count != 0 ? (
                        <div className="row">
                          <div class="mb-2 col-md-6 col-12">
                            <Link
                              to="/my-plans"
                              class="btn dash-card p-4 shadow-xl outline action-btn w-100"
                              target="_self"
                            >
                              <Pie data={doudata} />
                            </Link>
                          </div>
                          <div class="mb-2 col-md-6 col-12">
                            <Link
                              to="/my-plans"
                              class="btn dash-card p-4 shadow-xl outline evest action-btn w-100"
                              target="_self"
                            >
                              
                              <h3
                                  style={{
                                    marginTop: "50px",
                                    fontStyle: "italic",
                                    textTransform: "capitalize"
                                  }}
                                  className="text-dark"
                                >
                                  You have {this.state.plan_count} active plans
                                </h3>
                              <Link
                                to="/my-plans"
                                className="btn btn-primary mt-4"
                                style={{
                                  marginRight: "0px",
                                  backgroundColor: "",
                                }}
                              >
                                View All Plans
                              </Link>
                            </Link>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Page>
      </>
    );
  }
}

export default Dashboard;
